module.exports = __webpack_public_path__ + "img/pmonth3.5168bdd2.png";